export const GET_USER_GROUPS = 'getUserGroups';
export const CREATE_USER_GROUPS = 'createUserGroup';
export const UPDATE_USER_GROUP = 'updateUserGroup';
export const DELETE_USER_GROUP = 'deleteUserGroup';
export const UNLINK_USER_FROM_GROUP = 'unlinkUserFromGroup';
export const GET_EXISTING_MANAGER_USERS = 'getExistingManagerUsers';
export const LINK_EXISTING_USER_TO_GROUP = 'linkExistingUserToGroup';